import { FC } from 'react'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import PrimaryButton from '@organisms/PrimaryButton'
import { getEventName } from '@modals/RiskMapModal/Dangers/nameUtils'
import Modal from '@organisms/Modal'
import { useAppSelector } from '@hooks/useAppSelector'
import useProtectionMeansModal from './useProtectionMeansModal'
import ProtectionMeansFields from './ProtectionMeansFields'

type Props = {
  index: number
}

const DangersFieldsProtectionMeansModalButton: FC<Props> = ({ index }) => {
  const methods = useFormContext()
  const { watch } = methods

  const protectionMeansIsVisibleIndex = useAppSelector(
    (state) => state.riskMapModal.protectionMeansIsVisibleIndex
  )

  const {
    openProtectionMeans,
    closeProtectionMeans,
    protectionMeansIsLoading,
  } = useProtectionMeansModal(methods, index)

  const event = watch(getEventName(index))

  return (
    <>
      <PrimaryButton
        disabled={!event}
        onClick={openProtectionMeans}
        id="risk-map-danger-fill-protectionMean"
        isLoading={protectionMeansIsLoading}
      >
        Заполнить СИЗ
      </PrimaryButton>
      <Modal
        visible={protectionMeansIsVisibleIndex === index}
        onModalClose={closeProtectionMeans}
        withoutCloseOnOutsideClick
      >
        <ProtectionMeansFields
          event={event}
          dangerousIndex={index}
          onModalClose={closeProtectionMeans}
        />
      </Modal>
    </>
  )
}

export default DangersFieldsProtectionMeansModalButton
